/*
 * Require an explicit size choice on product pages.
 *
 * Dawn preselects the first available variant (XS for the corsets), so a shopper can add the
 * wrong size without ever choosing one. This leaves the variant logic alone and only:
 *   1. shows the size pills as unselected until the shopper clicks one,
 *   2. blocks the add-to-cart submit until they have, with an inline message.
 * Pages opened with ?variant=... (deep links, cart edits) and products with a single size are skipped.
 */
(function () {
  if (new URLSearchParams(window.location.search).has('variant')) return;

  var chosen = false;
  var STYLE_ID = 'size-required-style';
  var MESSAGE_CLASS = 'size-required-message';

  function sizeFieldsets(root) {
    var found = [];
    (root || document).querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend && /size/i.test(legend.textContent) && fieldset.querySelectorAll('input[type="radio"]').length > 1) {
        found.push(fieldset);
      }
    });
    return found;
  }

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.size-unchosen input[type="radio"]:checked + label{' +
      'background-color:rgb(var(--color-background));color:rgba(var(--color-foreground),.75);' +
      'border-color:rgba(var(--color-foreground),.55);box-shadow:none}' +
      '.' + MESSAGE_CLASS + '{color:#b00020;font-size:1.3rem;margin:.6rem 0 0}';
    document.head.appendChild(style);
  }

  // Inline !important styles on the preselected pill's label guarantee it can't look "chosen" while unchosen,
  // whatever the theme's own CSS does.
  function styleLabel(fieldset, unchosen) {
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = input.id ? fieldset.querySelector('label[for="' + input.id + '"]') : null;
      if (!label) return;
      ['background-color', 'color', 'border-color', 'box-shadow'].forEach(function (prop) {
        if (unchosen && input.checked) {
          var v = prop === 'background-color' ? 'rgb(var(--color-background))' : prop === 'color' ? 'rgba(var(--color-foreground), .75)' : prop === 'border-color' ? 'rgba(var(--color-foreground), .55)' : 'none';
          label.style.setProperty(prop, v, 'important');
        } else {
          label.style.removeProperty(prop);
        }
      });
    });
  }

  function markUnchosen() {
    if (chosen) return;
    sizeFieldsets().forEach(function (fieldset) {
      fieldset.classList.add('size-unchosen');
      styleLabel(fieldset, true);
    });
  }

  function markChosen() {
    chosen = true;
    document.querySelectorAll('.size-unchosen').forEach(function (fieldset) {
      fieldset.classList.remove('size-unchosen');
      styleLabel(fieldset, false);
    });
    document.querySelectorAll('.' + MESSAGE_CLASS).forEach(function (node) {
      node.remove();
    });
  }

  function showMessage(fieldset) {
    if (fieldset.querySelector('.' + MESSAGE_CLASS)) return;
    var message = document.createElement('p');
    message.className = MESSAGE_CLASS;
    message.setAttribute('role', 'alert');
    message.textContent = 'Please choose your size before adding to cart.';
    fieldset.appendChild(message);
  }

  function init() {
    var fieldsets = sizeFieldsets();
    if (!fieldsets.length) return;
    addStyle();
    markUnchosen();

    // Any click or keyboard change inside a size group counts as a choice (a plain click on the
    // already-checked pill fires no change event, so listen for clicks too).
    document.addEventListener('click', function (event) {
      var fieldset = event.target.closest && event.target.closest('fieldset.product-form__input');
      if (fieldset && sizeFieldsets().indexOf(fieldset) !== -1) markChosen();
    });
    document.addEventListener('change', function (event) {
      var fieldset = event.target.closest && event.target.closest('fieldset.product-form__input');
      if (fieldset && sizeFieldsets().indexOf(fieldset) !== -1) markChosen();
    });

    // Block add-to-cart until a size is chosen. Capture phase runs before Dawn's product-form.js.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (chosen || !form.matches || !form.matches('form[id^="product-form"]')) return;
        var unchosen = sizeFieldsets();
        if (!unchosen.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showMessage(unchosen[0]);
        try {
          unchosen[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          unchosen[0].animate([{ outline: '2px solid #b00020', outlineOffset: '6px' }, { outline: '2px solid transparent', outlineOffset: '6px' }], { duration: 1200 });
        } catch (e) {}
        var firstPill = unchosen[0].querySelector('input[type="radio"]');
        if (firstPill) firstPill.focus();
      },
      true
    );

    // Dawn re-renders the variant picker when options change; keep the unselected look until chosen.
    var info = document.querySelector('product-info');
    if (info) {
      new MutationObserver(markUnchosen).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
